module.exports = __webpack_public_path__ + "static/hero-resources-3207f390ee48bbdc9b7ece6e5877229c.svg";